import "react-image-lightbox/style.css";
import "./Map.scss";

import * as d3 from "d3";

import { ObjectInterface, ensureCoordinates } from "../../helpers/objectInterface";
import { useEffect, useRef, useState, useMemo } from "react";
import { descriptionBoxStyle } from "../../helpers/mixHelpers";
import { getTransformScale, handleMouseOut } from "../../helpers/transformation";
import { getThumbSizeAtScale, getIconSizeAtScale, getStrokeWidthAtScale, getFontSizeAtScale, getXOffsetAtScale } from "../../helpers/zoomHelper";
import { toast } from "react-toastify";
import { useContainerSize } from "../../helpers/resizeHelper";

import Lightbox from "react-image-lightbox";
import { Line } from "rc-progress";
import PropTypes from "prop-types";
import { Random } from "random-js";
import Search from "./Search";
import ShareButtons from "./ShareButtons";
import exoplanet from "../../images/green-planet.svg";
import exoplanetGrey from "../../images/green-planet-grey.svg";
import exotic from "../../images/exotic.svg";
import exoticGrey from "../../images/exotic-grey.svg";
import galaxy from "../../images/galaxy.svg";
import galaxyGrey from "../../images/galaxy-grey.svg";
import nebula from "../../images/nebula.svg";
import nebulaGrey from "../../images/nebula-grey.svg";
import searchIcon from "../../images/search.png";
import star from "../../images/star.svg";
import starGrey from "../../images/star-grey.svg";
import toggleIcon from "../../images/copy-icon.png";

// @ts-ignore
// This only needs to be imported once in your app
// @ts-ignore
let svg: any;
let zoom: any;
let node: any;
let currentSelect = -100;
let highlightIndex = -100;
let imgX = 6;
let imgY = 22;
let labX = 8;
let labY = 5;
let sharedObject: any;
let activeCategories = ["ST", "G", "N", "C", "P"];

//loader function
function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef();
  useEffect(() => {
    // @ts-ignore
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      // @ts-ignore
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

// noinspection JSUnusedLocalSymbols
export function Map(props: any) {

  const [starCategory, setStarCategory] = useState(true);
  const [galaxyCategory, setGalaxyCategory] = useState(true);
  const [nebulaCategory, setNebulaCategory] = useState(true);
  const [exoticCategory, setExoticCategory] = useState(true);
  const [exoplanetCategory, setExoplanetCategory] = useState(true);

  const { containerRef, sWidth, sHeight } = useContainerSize();

  const x = useMemo(
    () => d3.scaleLinear().range([0, sWidth]).domain([-180, 180]),
    [sWidth]
  );
  const y = useMemo(
    () => d3.scaleLinear().range([0, sHeight]).domain([-90, 90]),
    [sHeight]
  );

  // social sharing object START
  let shared_url = window.location.href ? window.location.href : "";
  let cm_object = shared_url.indexOf("#") > -1 ? shared_url.substring(shared_url.indexOf("#") + 1) : null;
  let base_url = (shared_url.indexOf("#") > -1) ? shared_url.slice(0, shared_url.indexOf("#")) : shared_url;

  if (cm_object != null) {
    d3.select("[c_m='" + cm_object + "']").each(function() {
      sharedObject = {
        x: d3.select(this).attr("x"),
        y: d3.select(this).attr("y"),
        c_m: d3.select(this).attr("c_m"),
        index: Number(d3.select(this).attr("index")),
      };
    });
    if (sharedObject !== undefined) {
      cm_object = null;
      window.history.pushState("object or string", "Title", base_url);
      sharedObjectHandleObjectClick(sharedObject);
    }
  }
  // social sharing object END

  /*
    Renders the Map
  */
  const [loadPercent, setLoadPercent] = useState(0);

  // image and label positions
  let [sImgX] = useState(6);
  let [sImgY] = useState(22);
  let [slabX] = useState(8);
  let [slabY] = useState(5);

  // light Box and legend bar values
  const [isLightBoxOpen, setLightBox] = useState(false);
  const [isSearchBoxEnable, setSearchBox] = useState(false);
  const [lightBoxImage, setLightBoxImage] = useState("");
  const [lightBoxFullImage, setLightBoxFullImage] = useState("");
  const [lightBoxTitle, setLightBoxTitle] = useState("");
  const [lightBoxDescription, setLightBoxDescription] = useState("");
  const [lightBoxUrl, setLightBoxUrl] = useState("");
  const [shareData, setShareData] = useState({});

  const setCategoryFilters = (catType: any, isActive: boolean) => {
    if (!isActive && catType === "ST") {
      const categoryIndex = activeCategories.indexOf("ST");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "ST") {
      activeCategories.push("ST");
    }

    if (!isActive && catType === "G") {
      const categoryIndex = activeCategories.indexOf("G");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "G") {
      activeCategories.push("G");
    }

    if (!isActive && catType === "N") {
      const categoryIndex = activeCategories.indexOf("N");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "N") {
      activeCategories.push("N");
    }

    if (!isActive && catType === "C") {
      const categoryIndex = activeCategories.indexOf("C");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "C") {
      activeCategories.push("C");
    }
    if (!isActive && catType === "P") {
      const categoryIndex = activeCategories.indexOf("P");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "P") {
      activeCategories.push("P");
    }
    if (isActive && catType === "All") {
      activeCategories = [];
      activeCategories = ["ST", "G", "N", "C", "P"];
    }
  };

  // zoom on searched object
  const handleSearchResult = (data: any) => {
    if (!data.length) {
      return false;
    }
    setSearchBox(false);
    d3.select("[c_m='" + data[0].cm_id + "']").each(function() {
      sharedObject = {
        x: d3.select(this).attr("x"),
        y: d3.select(this).attr("y"),
        c_m: d3.select(this).attr("c_m"),
        index: Number(d3.select(this).attr("index")),
      };
    });
    if (sharedObject !== undefined) {
      sharedObjectHandleObjectClick(sharedObject);
    }
  };

  const boxData = [
    "",
    <span key="1">
      <div className="row accordion">
        <div className="col">
          <div className="tabs">
            <div className="tab">
              <div className="social-buttons">
                <ShareButtons shareData={shareData} />
              </div>
              <input type="checkbox" id="checkbox_hide_info" />
              <label className="tab-label" htmlFor="checkbox_hide_info">
                <span className={"hide_info_label"}>Hide Info &nbsp;| &nbsp;</span>
                <span className={"show_info_label"}>Show Info &nbsp;| &nbsp;</span>
                <span>
                  <a href={lightBoxFullImage} target="_blank" rel="noopener noreferrer">
                    <span className="hide_info_a">See Full Image &nbsp;| &nbsp;</span>
                  </a>
                </span>
                <span>
                  <a href={lightBoxUrl} target="_blank" rel="noopener noreferrer">
                    <span className="hide_info_a">More Info</span>
                  </a>
                </span>
              </label>
              <div className="tab-content" style={descriptionBoxStyle}>
                <div>
                  <h2>{lightBoxTitle}</h2>
                  <span className="result-description">{lightBoxDescription}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>,
  ];
  // assigning state values to local variables
  imgX = sImgX;
  imgY = sImgY;
  labX = slabX;
  labY = slabY;

  function renderImage(sWidth: number, sHeight: number) {
    /*Renders background image*/
    [star, galaxy, nebula, exotic].forEach(
      (picture) => {
        const img = new Image();
        img.src = picture;
      },
    );

    // clear old svg before rerendering
    d3.select("#render_map2").selectAll("svg").remove();
    
    // @ts-ignore
    svg = d3.select("#render_map2").append("svg").attr("width", sWidth).attr("height", sHeight);
    node = svg.append("g").attr("class", "scale-holder").attr("transform", "translate(0, 0) scale(1)");

    zoom = d3
      .zoom<any, unknown>()
      .scaleExtent([1, 30])
      .translateExtent([
        [0, 0],
        [sWidth, sHeight],
      ])
      .on("zoom", zoomed);

    svg.call(zoom);
    /*
      Appends the image to node
    */
    const { origin, pathname } = window.location;
    let actualPath = pathname;
    if (pathname.endsWith('/index.html')) {
      actualPath = pathname.slice(0, -11);
    }
    const siteUrl = `${origin}${actualPath}`;
    
    let imgG = node.append("g");
    imgG
      .insert("svg:image")
      .attr("preserveAspectRatio", "none")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", sWidth)
      .attr("height", sHeight)
      .attr("xlink:href", `${siteUrl}/background_image_set/image-1.jpg`);
    imgG
      .insert("svg:image")
      .attr("preserveAspectRatio", "none")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", sWidth)
      .attr("height", sHeight)
      .attr("xlink:href", `${siteUrl}/background_image_set/image.jpg`);
    
      drawObjects();
  }

  function getActiveObjects() {
    return props.ObjectCoordinates.filter((el: any) => {
      return activeCategories.includes(el.category)
    }).sort((a: any, b: any) => {
      return a.cm_id.localeCompare(b.cm_id);
    });
  };

  function drawObjects() {
    // append shapes on background image
    const size = getIconSizeAtScale(getTransformScale(d3));
    const activeObjects = getActiveObjects();

    const rightEdge = Number(svg.attr('width'));
    const bottom = Number(svg.attr('height'));
    
    for (let index = 0; index < activeObjects.length; index++) {
      let objectInterface: ObjectInterface = activeObjects[index];

      const item = ensureCoordinates(objectInterface);
      
      let mY = y(item.latitude);
      let mX = x(item.longitude);
      let c_m = item.cm_id;
      let category = item.category;

      if (node.select(".coords[index='" + index + "']").size() === 0) {
        let shape = star;
        switch (item.category) {
          case "ST":
            shape = star;
            break;
          case "G":
            shape = galaxy;
            break;
          case "N":
            shape = nebula;
            break;
          case "C":
            shape = exotic;
            break;
          case "P":
            shape = exoplanet;
            break;
        }
        /*
          Inserts thumbnails on click
        */
        const rect = node
          .append("svg:image")
          .attr("class", "coords")
          .attr("preserveAspectRatio", "none")
          .attr("x", mX)
          .attr("y", mY)
          .attr("width", size)
          .attr("height", size)
          .attr("cursor", "pointer")
          .attr("index", index)
          .attr("c_m", c_m)
          .attr("category", category)
          .attr("xlink:href", shape)
          .attr("opacity", "0")
          .on("click", handleObjectClick)
          .on("mouseover", handleHover)
          // eslint-disable-next-line
          .on("mouseout", function() {
            handleMouseOut(index, currentSelect, node);
          }).each(function() {
              adjustOverflowIcons(this, mX, mY, size, rightEdge, bottom)
          });
        rect.transition().duration(new Random().integer(500, 2000)).attr("opacity", "1");
      }
    }

  }

  function resizeIcons(scale: number) {
    const iconSize = getIconSizeAtScale(scale);
    d3.selectAll('.coords')
      .attr('width', iconSize)
      .attr('height', iconSize);
  }

  function resizeThumbs(scale: number) {
    /*
      Resizes thumbnails on zoom
    */
    const imgSizeAtScale = getThumbSizeAtScale(scale);
    const strokeWidth = getStrokeWidthAtScale(scale);

    d3.selectAll(".rect-border, .hover_image").each(function () {
      const elem = d3.select(this);
      elem.attr('width', imgSizeAtScale)
        .attr('height', imgSizeAtScale)
    });
    d3.selectAll('.rect-border').style('stroke-width', `${strokeWidth}px`);
  }

  function resizeText(scale: number) {
    /*
      Resizes labels on zoom
    */
    const fontSize = getFontSizeAtScale(scale);
    const imgSizeAtScale = getThumbSizeAtScale(scale);
    const textHeight = (fontSize / 70) * 12; 

    d3.selectAll<SVGGraphicsElement, unknown>('.label')
      .attr('font-size', `${fontSize}%`)
      .attr('y', imgSizeAtScale + textHeight);
  }

  function resizeGroups(scale: number) {
    const imgSizeAtScale = getThumbSizeAtScale(scale);
    const iconSize = getIconSizeAtScale(scale);
    const baseOffset = (getXOffsetAtScale(scale) || 0.5) * iconSize;
    d3.selectAll('.thumbnail_group').each(function() {
      adjustThumbnailGroup(this, iconSize, baseOffset, imgSizeAtScale, scale)
    })
  }

  function adjustOverflowIcons(icon: any, iconX: any, iconY: any, iconSize: number, rightEdge: number, bottom: number) {
    if ((iconX + iconSize) > rightEdge) {
      d3.select(icon).attr('x', (rightEdge - iconSize));
    }
    if ((iconY + iconSize) > bottom) {
      d3.select(icon).attr('y', (bottom - iconSize));
    }
  }

  function adjustThumbnailGroup(group: any, iconSize: number, baseOffset: number, imageSize: number, scale: number) {
    const groupSel = d3.select(group);
    const iconX = Number(groupSel.attr('icon-x'));
    const iconY = Number(groupSel.attr('icon-y'));
    const rightEdge = Number(svg.attr('width'));
    const bottom = Number(svg.attr('height'));

    const text = groupSel.select('.label');

    const fontSize = getFontSizeAtScale(scale);
    const textHeight = (fontSize / 70) * 12;
  
    const baseTextWidth = Number(text.attr('data-base-width') || 0);
    const textWidth = baseTextWidth * (fontSize / 70);

    const groupHeight = imageSize + textHeight;
    const groupWidth = Math.max(imageSize, textWidth);

    // default to line up so that the bottom of the group
    // is aligned to the mid point of the icon
    let translateY = iconY - groupHeight + (iconSize / 2);
    if ((translateY + groupHeight) > bottom) {
      // don't let it get any lower than the actual bottom of the SVG
      translateY = bottom - groupHeight;
    } else if (translateY < 0) {
      // if it extends out the top, flip it to be below
      translateY = iconY + iconSize;
    }

    // default to be to the right of the icon
    let translateX = iconX + iconSize + baseOffset;

    if ((translateX + groupWidth) > rightEdge) {
      // if it extends past the right edge, flip it to the left
      translateX = iconX - baseOffset - groupWidth;
      // adjust for text being longer than image is wide
      if (textWidth > imageSize) {
        translateX += (textWidth - imageSize);
      }
      // flip the text
      text.attr('x', imageSize).attr('text-anchor', 'end');
    } else {
      text.attr('x', 0).attr('text-anchor', 'start')
    }

    // apply the adjustment
    groupSel.attr('transform', `translate(${translateX}, ${translateY})`)
    
  }

  function zoomed() {
    /*
      Handles changes needed to be performed on zoom
    */
    const transform = d3.event.transform;
    let scale = transform.k;
    node.attr("transform", d3.event.transform);

    resizeIcons(scale);
    resizeThumbs(scale);
    resizeText(scale);
    resizeGroups(scale);
  }

  // noinspection DuplicatedCode
  function boxZoom(x: number, y: number, zoomLevel: number) {
    /*
      Zooms in on objects
     */

    if (x * (zoomLevel - 1) > sWidth * (zoomLevel - 1.5)) {
      x = sWidth - sWidth / zoomLevel / 2;
    }
    if (x * (zoomLevel - 1) < sWidth * 0.5) {
      x = sWidth / zoomLevel / 2;
    }
    if (y * (zoomLevel - 1) > sHeight * (zoomLevel - 1.5)) {
      y = sHeight - sHeight / zoomLevel / 2;
    }
    if (y * (zoomLevel - 1) < sHeight * 0.5) {
      y = sHeight / zoomLevel / 2;
    }

    // @ts-ignore
    svg
      .transition()
      .duration(1000)
      .call(
        // @ts-ignore
        zoom.transform,
        d3.zoomIdentity
          .translate(sWidth / 2, sHeight / 2)
          .scale(zoomLevel)
          .translate(-x, -y),
      ).on('end', () => {
        let scale = getTransformScale(d3);
        resizeIcons(scale);
        resizeThumbs(scale);
        resizeText(scale);
        resizeGroups(scale);
      });
  }

  function sharedObjectHandleObjectClick(object: any) {
    highlightIndex = object.index;
    d3.selectAll(`.thumbnail_group`).remove();

    currentSelect = highlightIndex;

    const activeObjects = getActiveObjects();
    let item: ObjectInterface = activeObjects[highlightIndex];

    const { siteUrl } = props;

    let thumb_url: any = "";
    let full_url: any = "";
    let open_full_url: any = "";

    if (item.cm_id.includes("M") || item.cm_id.includes("C") || item.cm_id.includes("B") || item.cm_id.includes("E")) {  
      const imageFile = `${item.cm_id.toLowerCase()}.jpg`;
      thumb_url = `${siteUrl}/thumbnail_images/${imageFile}`;
      full_url = `${siteUrl}/lightbox_images/${imageFile}`;
      open_full_url = `${siteUrl}/full_size_image/${imageFile}`;
    }

    let moreInfoUrl: any = item.url;
    if (!moreInfoUrl) {
      moreInfoUrl = "#";
    }
    let description: string = "Description Not Available";
    if (item.description) {
      description = item.description
    }

    const newShareData = {
      title: item.name,
      description,
      linkUrl: `${siteUrl}/share/${item.cm_id.toLowerCase()}.html`,
      imageUrl: full_url // this is the /lightbox_images/ image
    }

    const iconX = Number(object.x);
    const iconY = Number(object.y);
    const c_m = object.c_m;

    let scale = getTransformScale(d3);
    const imgSizeAtScale = getThumbSizeAtScale(scale);
    const strokeWidth = getStrokeWidthAtScale(scale);
    const iconSize = getIconSizeAtScale(scale)
    const fontSizeAtScale = getFontSizeAtScale(scale);
    const baseOffset = (getXOffsetAtScale(scale) || 0.5) * iconSize;

    const group = node.append('g')
                      .attr('class', 'thumbnail_group')
                      .attr('transform', `translate(${iconX + iconSize + baseOffset + baseOffset}, ${iconY - imgSizeAtScale})`)
                      .attr('index', highlightIndex)
                      .attr('icon-x', iconX)
                      .attr('icon-y', iconY)
                      .attr('category', item.category);

    const thumbnail = group.append('svg:image')
                            .attr('class', 'hover_image')
                            .attr('index', highlightIndex)
                            .attr('c_m', c_m)
                            .attr('x', 0)
                            .attr('y', 0)
                            .attr('width', imgSizeAtScale)
                            .attr('height', imgSizeAtScale)
                            .attr('xlink:href', thumb_url);
    
    const border = group.append('rect')
                        .attr('class', 'rect-border')
                        .attr('x', 0)
                        .attr('y', 0)
                        .attr('width', imgSizeAtScale)
                        .attr('height', imgSizeAtScale)
                        .attr('cursor', 'pointer')
                        .attr('index', highlightIndex)
                        .attr('c_m', c_m)
                        .style('fill', 'transparent')
                        .style('stroke', 'green')
                        .style('stroke-width', `${strokeWidth}px`)
                        .on('click', () => {
                          setLightBox(true);
                          setLightBoxImage(full_url);
                          setLightBoxFullImage(open_full_url);
                          setLightBoxTitle(item.name || '');
                          setLightBoxDescription(description);
                          setLightBoxUrl(moreInfoUrl);
                          setShareData(newShareData);
                        });

    const text = group.append('text')
                      .attr('class', 'label')
                      .attr('fill', 'white')
                      .attr('font-family', 'Arial')
                      .attr('x', 0)
                      .attr('y', imgSizeAtScale)
                      .attr('index', highlightIndex)
                      .attr('c_m', c_m)
                      .attr('font-size', `${fontSizeAtScale}%`)
                      .html(item.name)
                      .attr('opacity', '0')
                      .each(function() {
                        const textBox = this.getBBox();
                        d3.select(this).attr('data-base-width', textBox.width);
                        d3.select(this).attr('y', imgSizeAtScale + textBox.height);
                        adjustThumbnailGroup(group.node(), iconSize, baseOffset, imgSizeAtScale, scale);
                      });

    text.transition().duration(new Random().integer(100, 1000)).attr('opacity', '1');

    const zoomTarget = calculateZoomTarget(iconX, iconY);
    boxZoom(zoomTarget.x, zoomTarget.y, 6);

  }

  function handleObjectClick() {
    const icon = this as HTMLElement;
    highlightIndex = Number(icon.getAttribute("index"));
    d3.selectAll(`.thumbnail_group:not([index='${highlightIndex}']`).remove();

    currentSelect = highlightIndex;

    const activeObjects = getActiveObjects();
    let item: ObjectInterface = activeObjects[highlightIndex];

    const { siteUrl } = props;

    let full_url: any = "";
    let open_full_url: any = "";

    if (item.cm_id.includes("M") || item.cm_id.includes("C") || item.cm_id.includes("B") || item.cm_id.includes("E")) {
      const imageFile = `${item.cm_id.toLowerCase()}.jpg`;
      full_url = `${siteUrl}/lightbox_images/${imageFile}`;
      open_full_url = `${siteUrl}/full_size_image/${imageFile}`;
    }

    let moreInfoUrl: any = item.url;
    if (!moreInfoUrl) {
      moreInfoUrl = "#";
    }
    let description: string = "Description Not Available";
    if (item.description) {
      description = item.description;
    }

    const newShareData = {
      title: item.name,
      description,
      linkUrl: `${siteUrl}/share/${item.cm_id.toLowerCase()}.html`,
      imageUrl: full_url // this is the /lightbox_images/ image
    }

    const iconX = Number(icon.getAttribute('x'));
    const iconY = Number(icon.getAttribute('y'));
    const c_m = icon.getAttribute('c_m');

    let scale = getTransformScale(d3);
    const imgSizeAtScale = getThumbSizeAtScale(scale);
    const strokeWidth = getStrokeWidthAtScale(scale);

    const group = node.select(`.thumbnail_group[index='${highlightIndex}']`)
    
    const border = group.append('rect')
                        .attr('class', 'rect-border')
                        .attr('x', 0)
                        .attr('y', 0)
                        .attr('width', imgSizeAtScale)
                        .attr('height', imgSizeAtScale)
                        .attr('cursor', 'pointer')
                        .attr('index', highlightIndex)
                        .attr('c_m', c_m)
                        .style('fill', 'transparent')
                        .style('stroke', 'green')
                        .style('stroke-width', `${strokeWidth}px`)
                        .on('click', () => {
                          setLightBox(true);
                          setLightBoxImage(full_url);
                          setLightBoxFullImage(open_full_url);
                          setLightBoxTitle(item.name || '');
                          setLightBoxDescription(description);
                          setLightBoxUrl(moreInfoUrl);
                          setShareData(newShareData);
                        });

    const zoomTarget = calculateZoomTarget(iconX, iconY);
    boxZoom(zoomTarget.x, zoomTarget.y, 6);
  }

  function calculateZoomTarget(iconX: number, iconY: number) {
    const iconSize = getIconSizeAtScale(6);
    const imageSize = getThumbSizeAtScale(6);
    const baseOffset = (getXOffsetAtScale(6) || 0.5) * iconSize;
    const rightEdge = Number(svg.attr('width'));

    let targetX = iconX + iconSize + baseOffset + (imageSize / 2);
    let targetY = iconY - (imageSize / 2);

    if ((iconX + iconSize + baseOffset + imageSize) > rightEdge) {
      targetX = iconX - baseOffset - (imageSize / 2);
    }

    if ((iconY - imageSize) < 0) {
      targetY = iconY + iconSize + (imageSize / 2);
    }

    return {
      x: targetX,
      y: targetY
    }
  }

  function handleHover() {
    const icon = this as HTMLElement;
    highlightIndex = Number(icon.getAttribute("index"));
    if (currentSelect !== highlightIndex) {
      if (node.select(`.hover_image[index='${highlightIndex}']`).size() === 0) {
        const activeObjects = getActiveObjects();
        let item: ObjectInterface = activeObjects[highlightIndex];
        let thumb_url: any = "";
        if (item.cm_id.includes("M") || item.cm_id.includes("C") || item.cm_id.includes("B") || item.cm_id.includes("E")) {
          thumb_url = `${props.siteUrl}/thumbnail_images/${item.cm_id.toLowerCase()}.jpg`;
        }

        const iconX = Number(icon.getAttribute('x'));
        const iconY = Number(icon.getAttribute('y'));
        const iconWidth = Number(icon.getAttribute('width'));
        const c_m = icon.getAttribute('c_m');

        let scale = getTransformScale(d3);
        const imgSizeAtScale = getThumbSizeAtScale(scale);
        const fontSizeAtScale = getFontSizeAtScale(scale);
        const baseOffset = (getXOffsetAtScale(scale) || 0.5) * iconWidth;

        const group = node.append('g')
                          .attr('class', 'thumbnail_group')
                          .attr('transform', `translate(${iconX + iconWidth + baseOffset}, ${iconY - imgSizeAtScale})`)
                          .attr('index', highlightIndex)
                          .attr('icon-x', iconX)
                          .attr('icon-y', iconY)
                          .attr('category', item.category);
        
        const thumbnail = group.append('svg:image')
                               .attr('class', 'hover_image')
                               .attr('index', highlightIndex)
                               .attr('c_m', c_m)
                               .attr('x', 0)
                               .attr('y', 0)
                               .attr('width', imgSizeAtScale)
                               .attr('height', imgSizeAtScale)
                               .attr('xlink:href', thumb_url);

        const text = group.append('text')
                          .attr('class', 'label')
                          .attr('fill', 'white')
                          .attr('font-family', 'Arial')
                          .attr('x', 0)
                          .attr('y', imgSizeAtScale)
                          .attr('index', highlightIndex)
                          .attr('c_m', c_m)
                          .attr('font-size', `${fontSizeAtScale}%`)
                          .html(item.name)
                          .attr('opacity', '0')
                          .each(function() {
                            const textBox = this.getBBox();
                            d3.select(this).attr('data-base-width', textBox.width);
                            d3.select(this).attr('y', imgSizeAtScale + textBox.height);
                            adjustThumbnailGroup(group.node(), iconWidth, baseOffset, imgSizeAtScale, scale);
                          });

        text.transition().duration(new Random().integer(100, 1000)).attr('opacity', '1');
      }
    }
  }

  useEffect(() => {
    if (sWidth === 0 || sHeight === 0) {
      return;
    }
    renderImage(sWidth, sHeight);
  }, [sWidth, sHeight])

  useEffect(() => {
    imgX = sImgX;
    imgY = sImgY;
    labX = slabX;
    labY = slabY;
  }, [imgX, imgY, labX, labY]);

  useEffect(() => {
    if (sWidth === 0 || sHeight === 0) {
      return;
    }
    //remove all object form canvas
    d3.selectAll(".coords").remove();
    drawObjects();
  }, [starCategory, galaxyCategory, nebulaCategory, exoticCategory, exoplanetCategory, sWidth, sHeight]);

  useEffect(() => {
    if (isSearchBoxEnable) {
      setCategoryFilters("All", true);
      //make all objects state active
      setExoticCategory(true);
      setGalaxyCategory(true);
      setNebulaCategory(true);
      setStarCategory(true);
      setExoplanetCategory(true);
    }
  }, [isSearchBoxEnable]);

  useEffect(() => {
    if (sWidth === 0 || sHeight === 0) {
      return;
    }
    if (props.ObjectCoordinates.length > 0) {
      drawObjects()
    }
  }, [props.ObjectCoordinates, sWidth, sHeight]);

  useEffect(() => {
    if (props.error) {
      toast.error(<div>{props.error}<br/>Please refresh and try again.</div>, { autoClose: false, position: 'top-center' });
    }
  }, [props.error])

  useInterval(() => {
    if (loadPercent < 100) {
      if (props.isLoading && loadPercent < 50) {
        setLoadPercent(loadPercent + 25)
      } else if (!props.isLoading) {
        setLoadPercent(loadPercent + 25)
      }
    }
  }, 100);

  return (
    <>
      <div ref={containerRef} className="size-observer">
      <div
        id="render_map2"
        style={{
          width: sWidth + "px",
          height: sHeight + "px",
          margin: "0 auto",
          overflow: "hidden",
        }}
        className={loadPercent >= 100 ? "" : "hidden"}
      >
        <div className="tabs" id="first_tabs_sec">
          <div className="tab inner_tab">
            <label className="tab-label inner_label">
              <img
                onClick={() => {
                  setSearchBox(!isSearchBoxEnable);
                }}
                className="search-img"
                src={searchIcon}
                alt={"search-icon"} />
            </label>
            <input type="checkbox" id="check_1" />
            <label className="tab-label inner_label" htmlFor="check_1">
              <img src={toggleIcon} alt={"Copy icon"} />
            </label>
            <div className="tab-content inner_content">
              <input
                type="checkbox"
                id="starSwitch"
                className="categoryInput"
                checked={starCategory}
                onChange={() => {
                  setStarCategory(!starCategory);
                  setCategoryFilters("ST", !starCategory);
                  if (starCategory) {
                    // changing from true to false
                    d3.selectAll(`.thumbnail_group[category="ST"]`).remove();
                  }
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="starSwitch">
                <img src={(starCategory) ? star : starGrey} alt="star" />
                Stars
              </label>
              <input
                type="checkbox"
                id="galaxySwitch"
                className="categoryInput"
                checked={galaxyCategory}
                onChange={() => {
                  setGalaxyCategory(!galaxyCategory);
                  setCategoryFilters("G", !galaxyCategory);
                  if (galaxyCategory) {
                    // changing from true to false
                    d3.selectAll(`.thumbnail_group[category="G"]`).remove();
                  }
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="galaxySwitch">
                <img src={(galaxyCategory) ? galaxy : galaxyGrey} alt="galaxy" />
                Galaxies
              </label>
              <input
                type="checkbox"
                id="nebulaSwitch"
                className="categoryInput"
                checked={nebulaCategory}
                onChange={() => {
                  setNebulaCategory(!nebulaCategory);
                  setCategoryFilters("N", !nebulaCategory);
                  if (nebulaCategory) {
                    // changing from true to false
                    d3.selectAll(`.thumbnail_group[category="N"]`).remove();
                  }
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="nebulaSwitch">
                <img src={(nebulaCategory) ? nebula : nebulaGrey} alt="nebula" />
                Nebula
              </label>
              <input
                type="checkbox"
                id="exoticSwitch"
                className="categoryInput"
                checked={exoticCategory}
                onChange={() => {
                  setExoticCategory(!exoticCategory);
                  setCategoryFilters("C", !exoticCategory);
                  if (exoticCategory) {
                    // changing from true to false
                    d3.selectAll(`.thumbnail_group[category="C"]`).remove();
                  }
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="exoticSwitch">
                <img src={(exoticCategory) ? exotic : exoticGrey} alt="exotic" />
                Exotic
              </label>
              <input
                type="checkbox"
                id="exoplanetSwitch"
                className="categoryInput"
                checked={exoplanetCategory}
                onChange={() => {
                  setExoplanetCategory(!exoplanetCategory);
                  setCategoryFilters("P", !exoplanetCategory);
                  if (exoplanetCategory) {
                    // changing from true to false
                    d3.selectAll(`.thumbnail_group[category="P"]`).remove();
                  }
                  setSearchBox(false);
                }}
              />
              <label className="legendButtons" htmlFor="exoplanetSwitch">
                <img src={(exoplanetCategory) ? exoplanet : exoplanetGrey} alt="Exoplanet" />
                Exoplanet
              </label>
            </div>
          </div>
        </div>
        {isSearchBoxEnable && (
          <div className="loader-search">
            <div className="search_modal">
              <div className="search_bar">
                <Search options={props.ObjectCoordinates} handleSearchResult={handleSearchResult} />
              </div>
            </div>
          </div>
        )}
        {isLightBoxOpen && (
          <>
            <Lightbox
              animationDisabled={true}
              enableZoom={false}
              mainSrc={lightBoxImage}
              imageCaption={boxData}
              onCloseRequest={() => {
                setLightBox(!isLightBoxOpen);
                setLightBoxImage("");
              }}
            />
          </>
        )}
      </div>
      </div>
      <div className={"loader " + (loadPercent >= 100 ? "loaded" : "")}>
        <div className="loader-inner">
          <Line percent={loadPercent} strokeWidth={2} strokeColor="#D3D3D3" />
        </div>
      </div>
    </>
  );
}

Map.prototype = {
  sharedObjectCm: PropTypes.any,
  baseUrl: PropTypes.any,
};
export default Map;
